// @see https://bitbucket.org/flightscope/dto-schema/src/master/baseball/entity/session-lineup-v2.json

import LineupType from "./LineupType.js";

const Lineup = {
    SessionID: { key: 'sessionID', name: 'sessionID', type: 'NUMBER' },
    Type: { key: 'type', name: 'type', enum: LineupType },
    TeamID: { key: 'teamID', name: 'teamID', type: 'NUMBER' },

    BattingOrder: { key: 'battingOrder', name: 'battingOrder', type: 'ARRAY' },
    Bench: { key: 'bench', name: 'bench', type: 'ARRAY' },
    Substitutions: { key: 'substitutions', name: 'substitutions', type: 'ARRAY' },
    Switches: { key: 'switches', name: 'switches', type: 'ARRAY' },
};

export default Lineup;